import React from 'react';

import List from './message-template-type/List'

function MessageTemplateType(){
	return(
	
			<List/>
			
	
	);
}

export default MessageTemplateType;